import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import { alpha } from '@mui/material/styles'
import { FLAG_LABEL, MovementStatus } from '../types'

type ChipStyle = {
	label: string,
	title: string,
	colorKey: 'error' | 'info',
}

const STATUS_STYLES: Record<Exclude<MovementStatus, 'completed'>, ChipStyle> = {
	cancelled: { label: 'Cancelled', title: FLAG_LABEL.cancelled, colorKey: 'error' },
	in_transit: { label: 'In transit', title: FLAG_LABEL.in_transit, colorKey: 'info' },
}

/**
 * Status badge for a movement that is not a plain completed one. Nothing renders for
 * `completed`, which is the overwhelming majority of rows — a badge on every row would
 * carry no signal.
 *
 * Cancelled reads as error-toned because the row's quantity never moved and the delta
 * would otherwise be believed; in-transit reads as informational because the quantity
 * did move and only the receipt is outstanding.
 */
export default function StatusChip( { status }: { status: MovementStatus } ) {
	if ( status === 'completed' ) {
		return null
	}
	const { label, title, colorKey } = STATUS_STYLES[ status ]

	return (
		<Tooltip title={title} arrow>
			<Box
				component="span"
				sx={{
					display: 'inline-flex',
					alignItems: 'center',
					px: 0.75,
					py: 0.125,
					borderRadius: 0.5,
					fontSize: 11,
					fontWeight: 600,
					lineHeight: 1.5,
					letterSpacing: 0.2,
					textTransform: 'uppercase',
					whiteSpace: 'nowrap',
					cursor: 'help',
					color: `${colorKey}.dark`,
					bgcolor: ( theme ) => alpha( theme.palette[ colorKey ].main, 0.14 ),
				}}
			>
				{label}
			</Box>
		</Tooltip>
	)
}
